import {useCallback} from 'react';

import {Input, InputProps} from 'components';

type Props = InputProps & {
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const InputAdapter: React.FC<Props> = ({
    onChange,
    ...rest
}) => {
    const handleChange = useCallback(
        (value: string, originalEvent: React.ChangeEvent<HTMLInputElement>) => {
            onChange?.(originalEvent);
        }, [onChange]
    );

    return (
        <Input
            {...rest}
            onChange={handleChange}
        />
    );
};
